import React from 'react';
import './DemoWinItem.css'
import editIcon from '../assets/edit-icon.png';
import deleteIcon from '../assets/delete-icon.png';

const DemoWinItem: React.FC<{content: string}> = (props) => {

  return (
    <div className='demo-win-item'>
      <div className='demo-win-item-button-containers'>
        <div className='demo-win-item-edit-container'>
          <img src={editIcon} alt='Edit Icon' />
        </div>
        <div className='demo-win-item-delete-container'>
          <img src={deleteIcon} alt='Delete Icon' />
        </div>
      </div>
      <div className='demo-win-content'>
        {props.content}
      </div>
    </div>
  );
};

export default DemoWinItem;
